export const GET_INFORMACION_GUIA="GET_INFORMACION_GUIA";
export const GET_MENSAJES="GET_MENSAJES";
export const READ_NOTIFICACION="READ_NOTIFICACION";
export const PERMISOS_NOTIFICACION="PERMISOS_NOTIFICACION";